{
  "version": 1,
  "asset_id": "522830f4-1ca0-4ef5-a246-3923465bb8b5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/522830f4-1ca0-4ef5-a246-3923465bb8b5/hiatal-recurrent-redo-2-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/522830f4-1ca0-4ef5-a246-3923465bb8b5/hiatal-recurrent-redo-2-800.webp",
  "original_filename": "hiatal-recurrent-redo-2-800.webp",
  "size": 80770,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:24Z"
}
